import React, { useState, useEffect, useContext } from 'react';
import icon_close from '../../assets/images/icon-close.svg';

export default ({isQueryPending, onCloseModal, onDeleteMaintenance}) => {

  return (
    <>
      <div className="modal-header">
        <h2 className="form-heading">Delete Maintenance</h2>
        <img className="modal-close" src={icon_close} alt="Close Icon" onClick={onCloseModal} />
      </div>

      <div className="modal-content">
        <div className="inner">
          <p>Are you sure you want to delete this maintenance report? Deleting cannot be undone.</p>
        </div>
        <div className="modal-actions">
          <button className="button small red" disabled={isQueryPending} onClick={onDeleteMaintenance} >
            Delete Maintenance
          </button>
        </div>
      </div>
    </>
  )
}